import React from 'react';

const Wadhamini = () => {
    const sponsors = [
        {
            id: 1,
            title: "Bodi ya Wadhamini",
            description: "Wajumbe wa Bodi ya Wadhamini wa CPCT",
            image: "https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/wadhamini%2FWadhamini.jpg?alt=media&token=ba5c1f34-3ac8-4fdb-b855-fbf98d6a0a6f"
        },
        // {
        //     id: 2,
        //     title: "Wadhamini wa CPCT",
        //     description: "Wadhamini wa CPCT ni watu binafsi na mashirika ambayo yamekuwa na uhusiano wa muda mfupi na kanisa letu. Wamekuwa wakitusaidia kwa njia mbalimbali, ikiwa ni pamoja na kifedha, kiroho, na kimwili.",
        //     image: "https://lh3.googleusercontent.com/aida-public/AB6AXuBBmRAbwkAnzKJSj8275Gd6Pg1dOKPDiIefReXRJR2OPLhr7lRyzIxV4LdH-3JkaJx70eQhd0bWH4jw7_qvFcoyiJqhhbOOMMOeSAomjz5Nz2fAxIq7zQDW7Xw9BMghKO4VswysB6IKEZ_8VfPX-AuuZ9fRQRFBGMZDMMIjvGiuFTm2TaaykSFefhBR3IvkiBXtYnTTpogFBL2-zu9MTCycsil1TbykG8VVVSa5npuMiWWbpwP_ItUh0LvsImYEs3IM5NWKB0zxlw"
        // },
        // {
        //     id: 3,
        //     title: "Washirika wa CPCT",
        //     description: "Washirika wa CPCT ni watu binafsi na mashirika ambayo yamekuwa na uhusiano wa muda mrefu na kanisa letu. Wamekuwa wakitusaidia kwa njia mbalimbali, ikiwa ni pamoja na kifedha, kiroho, na kimwili.",
        //     image: "https://lh3.googleusercontent.com/aida-public/AB6AXuCHD_JNBEqz3HpWCtzCRWssVSAExbMPhK4ex0qi3lUoibLaIpsetA6JNMbP98ZYuH4Mp0usdIaUTdpnpkWAvE_qi9fcklbqZwjEtsPXjWHJ3bxop8b-Tk1FPSLhHxmazcTjwrLB0WPk1zIXI39J5SNfQMzMLp2cZkMcVhpqkQaQ6ozpCX82vcYRQ68PB12_TJrxf3zBI7tUSQCFrKKNsQEl2UFcVGIpVUkxwV0WANLFNm1EB7HT0_MY8BV4Or2Jlue1wTai08c0jw"
        // }
    ];

    return (
        <div className=" font-display text-slate-800 dark:text-slate-200">

            <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-10">
                <div className="max-w-4xl mx-auto">

                    <div className="bg-white dark:from-purple-900/20 text-lg dark:to-pink-900/20 rounded-2xl shadow-lg p-8">
                        <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Bodi ya Wadhamini</h3>
                        <div className="text-gray-700 dark:text-gray-300">
                            Bodi ya Wadhamini wa Mali za CPCT watakuwa ni wajumbe saba.
                            Kusudi la Bodi ya Wadhamini itakayokuwa msimamizi, na mtunzaji wa mali za CPCT kwa niaba ya
                            Baraza.
                            <br></br>
                            <br></br>
                            Jina la Bodi Bodi ya Wadhamini iliyosajiliwa kwa mujibu wa Sheria za Jamhuri ya Muungano wa
                            Tanzania itaitwa <b className={''}>THE
                            REGISTERED TRUSTEES OF THE COUNCIL OF PENTECOSTAL CHURCHES OF TANZANIA</b>.
                            <br></br>
                            <hr className="border-t border-gray-300 my-4"/>
                            <h2 className={'font-bold text-lg'}>Wajumbe wa Bodi</h2>
                            Bodi ya wadhamini itakuwa na wajumbe saba kama ifuatavyo:<br></br>
                            <ol>
                                <li>1. Mwenyekiti wa CPCT Taifa</li>
                                <li>2. Katibu Mkuu wa CPCT Taifa, na</li>
                                <li>3. Wajumbe wengine watano</li>
                            </ol>
                        </div>
                    </div>

                    {/*<div className="grid mt-8 sm:grid-cols-2 lg:grid-cols-3 gap-8">*/}
                    {/*    {sponsors.map((sponsor) => (*/}
                    {/*        <div key={sponsor.id} className="bg-white dark:bg-slate-800 rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-shadow duration-300 border border-gray-200 dark:border-slate-700">*/}
                    {/*            <div*/}
                    {/*                className="w-full h-48 bg-cover bg-center bg-gray-200"*/}
                    {/*                style={{ backgroundImage: `url(${sponsor.image})` }}*/}
                    {/*            ></div>*/}
                    {/*            <div className="p-6">*/}
                    {/*                <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">{sponsor.title}</h3>*/}
                    {/*                <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">{sponsor.description}</p>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    ))}*/}
                    {/*</div>*/}
                </div>
            </main>
        </div>
    );
};

export default Wadhamini;